import axios from 'axios';
import request from '../../helpers/interceptorRequest';
import response from '../../helpers/interceptorResponse';

const httpClient = axios.create({
	baseURL: process.env.VUE_APP_API_URL,
	timeout: 60000,
	headers: {
		'Content-Type': 'application/json',
		accept: 'application/json',
	},
	withCredentials: true,
});

httpClient.interceptors.request.use(request.success, request.error);
httpClient.interceptors.response.use(response.success, response.error);

export default httpClient;